import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import { API_URL, getMediaURL } from '../config';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [siteInfo, setSiteInfo] = useState(null);
  const location = useLocation();
  const isServiceDetail = location.pathname.includes('/services/');
  const isBlogDetail = location.pathname.match(/^\/blog\/\d+/); // /blog/123 gibi URL'leri yakalar
  const isBlog = location.pathname.startsWith('/blog');

  useEffect(() => {
    const handleScroll = () => {
      if (!isServiceDetail && !isBlogDetail) {
        setIsScrolled(window.scrollY > 0);
      }
    };

    // Sadece ServiceDetail ve BlogDetail sayfalarında her zaman beyaz tema
    if (isServiceDetail || isBlogDetail) {
      setIsScrolled(true);
    }

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [isServiceDetail, isBlogDetail]);

  useEffect(() => {
    const fetchSiteInfo = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/site-infos?populate=*`);
        console.log('Navbar API Response:', response.data);
        
        if (response.data?.data && response.data.data.length > 0) {
          const data = response.data.data[0];
          console.log('Navbar Site Info:', data);
          setSiteInfo(data);
        }
      } catch (error) {
        console.error('Error fetching site info:', error);
      }
    };

    fetchSiteInfo();
  }, []);

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-24">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to="/" className="flex items-center">
              {siteInfo?.logo?.url ? (
                <img 
                  src={getMediaURL(siteInfo.logo.url)}
                  alt={siteInfo.title || 'Site Logo'}
                  className={`h-16 w-auto ${isScrolled ? 'brightness-0' : 'brightness-100'}`}
                />
              ) : (
                <span className={`text-2xl font-bold ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
                  {siteInfo?.title || 'WIND LAW'}
                </span>
              )}
            </Link>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-center space-x-6">
              <div className="flex items-baseline space-x-4">
                <Link to="/" className={`px-3 py-2 rounded-md text-sm font-medium ${isScrolled ? 'text-gray-900 hover:text-gray-700' : 'text-white hover:text-gray-300'}`}>
                  Ana Sayfa
                </Link>
                <Link to="/about" className={`px-3 py-2 rounded-md text-sm font-medium ${isScrolled ? 'text-gray-900 hover:text-gray-700' : 'text-white hover:text-gray-300'}`}>
                  Hakkımda
                </Link>
                <Link to="/services" className={`px-3 py-2 rounded-md text-sm font-medium ${isScrolled ? 'text-gray-900 hover:text-gray-700' : 'text-white hover:text-gray-300'}`}>
                  Çalışma Alanları
                </Link>
                <Link to="/blog" className={`px-3 py-2 rounded-md text-sm font-medium ${isScrolled ? 'text-gray-900 hover:text-gray-700' : 'text-white hover:text-gray-300'}`}>
                  Blog
                </Link>
              </div>
              <Link 
                to="/contact" 
                className={`px-4 py-2 rounded-md text-sm font-medium border-2 transition-colors
                  ${isScrolled 
                    ? 'border-primary text-primary hover:bg-primary hover:text-white' 
                    : 'border-white text-white hover:bg-white hover:text-primary'
                  }`}
              >
                İletişime Geç
              </Link>
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className={`inline-flex items-center justify-center p-2 rounded-md ${
                isScrolled ? 'text-gray-900 hover:text-gray-700' : 'text-white hover:text-gray-300'
              }`}
            >
              <span className="sr-only">Open main menu</span>
              {!isMenuOpen ? (
                <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              ) : (
                <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden">
          <div className={`px-2 pt-2 pb-3 space-y-1 sm:px-3 ${isScrolled ? 'bg-white' : 'bg-black bg-opacity-90'}`}>
            <Link to="/" onClick={closeMenu} className={`block px-3 py-2 rounded-md text-base font-medium ${isScrolled ? 'text-gray-900 hover:text-gray-700' : 'text-white hover:text-gray-300'}`}>
              Ana Sayfa
            </Link>
            <Link to="/about" onClick={closeMenu} className={`block px-3 py-2 rounded-md text-base font-medium ${isScrolled ? 'text-gray-900 hover:text-gray-700' : 'text-white hover:text-gray-300'}`}>
              Hakkımda
            </Link>
            <Link to="/services" onClick={closeMenu} className={`block px-3 py-2 rounded-md text-base font-medium ${isScrolled ? 'text-gray-900 hover:text-gray-700' : 'text-white hover:text-gray-300'}`}>
              Çalışma Alanları
            </Link>
            <Link to="/blog" onClick={closeMenu} className={`block px-3 py-2 rounded-md text-base font-medium ${isScrolled ? 'text-gray-900 hover:text-gray-700' : 'text-white hover:text-gray-300'}`}>
              Blog
            </Link>
            <Link 
              to="/contact" 
              onClick={closeMenu}
              className={`block px-4 py-2 rounded-md text-base font-medium border-2 text-center
                ${isScrolled 
                  ? 'border-primary text-primary hover:bg-primary hover:text-white' 
                  : 'border-white text-white hover:bg-white hover:text-primary'
                }`}
            >
              İletişime Geç
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
